import { useCallback } from 'react';
import { usePersistentStorage } from '#shared/lib/storage';
import { GSC_ONBOARDING_INTEGRATIONS_VISITED_STORAGE_KEY } from '../lib/constants';
import { getGscOnboardingState } from '../lib/getGscOnboardingState';

interface UseGscOnboardingMenuNotificationParams {
    isConnected: boolean;
    isConnectionStatusResolved: boolean;
}

export const useGscOnboardingMenuNotification = ({
    isConnected,
    isConnectionStatusResolved,
}: UseGscOnboardingMenuNotificationParams) => {
    const [isIntegrationsVisited] = usePersistentStorage<'1'>(GSC_ONBOARDING_INTEGRATIONS_VISITED_STORAGE_KEY);

    return getGscOnboardingState({
        isConnected,
        isConnectionStatusResolved,
        isIntegrationsVisited: isIntegrationsVisited === '1',
    }).hasMenuNotification;
};

export const useMarkGscOnboardingIntegrationsVisited = () => {
    const [isIntegrationsVisited, setIsIntegrationsVisited] = usePersistentStorage<'1'>(
        GSC_ONBOARDING_INTEGRATIONS_VISITED_STORAGE_KEY
    );

    return useCallback(() => {
        if (isIntegrationsVisited === '1') {
            return;
        }

        setIsIntegrationsVisited('1');
    }, [isIntegrationsVisited, setIsIntegrationsVisited]);
};
